import messages from './messages.js';

const DEFAULT_LANG = 'ca_es';

export function normalizeLang (lang) {
  return (lang || DEFAULT_LANG).toLowerCase().replace('-', '_');
}

/** Traducciones fijas de UI */
export function t (key, lang) {
  const l = normalizeLang(lang);
  return (messages[l] || messages[DEFAULT_LANG])[key] || key;
}

/**
 * Resuelve textos configurables.
 * Acepta:
 *   - string plano → lo devuelve tal cual (compatibilidad)
 *   - objeto  { ca_es, es_es, en_gb } → devuelve el idioma pedido
 *   - string JSON { "ca_es":..., "es_es":..., "en_gb":... } → parsea y devuelve
 */
export function tConfig (value, lang) {
  if (!value && value !== 0) return '';
  if (typeof value === 'object') {
    const l = normalizeLang(lang);
    return value[l] || value[DEFAULT_LANG] || Object.values(value)[0] || '';
  }
  if (typeof value === 'string' && value.trimStart().startsWith('{')) {
    try {
      const parsed = JSON.parse(value);
      const l = normalizeLang(lang);
      return parsed[l] || parsed[DEFAULT_LANG] || Object.values(parsed)[0] || value;
    } catch { /* fall through */ }
  }
  return value;
}
